import { render, staticRenderFns } from "./Landpage.vue?vue&type=template&id=7f74f14f&scoped=true&"
import script from "./Landpage.vue?vue&type=script&lang=js&"
export * from "./Landpage.vue?vue&type=script&lang=js&"
import style0 from "./Landpage.vue?vue&type=style&index=0&id=7f74f14f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74f14f",
  null
  
)

export default component.exports